function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M13.61 2.77a2.32 2.32 0 0 0-1.71 2.56 2.27 2.27 0 0 0 2.63 1.91 2.14 2.14 0 0 0 1.3-.71 2.18 2.18 0 0 0 .56-1.06 2.39 2.39 0 0 0-.06-1.19 2.28 2.28 0 0 0-1.46-1.46 2.56 2.56 0 0 0-1.26 0z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M16.11 1A4.43 4.43 0 0 0 15 .62a5.2 5.2 0 0 0-1.76 0A4.46 4.46 0 0 0 9.83 4a5 5 0 0 0-.11.64v.3l-1.44 2-1.43 2h-.32A3.26 3.26 0 0 0 5 9.4l-.14.08L3 8.68.5 7.64v4.16l.5.2 2.37 1v.2a3.65 3.65 0 0 0 1.39 2 3.45 3.45 0 0 0 3.67.11A3.37 3.37 0 0 0 9.77 14a3.29 3.29 0 0 0 .4-1.35v-.24l1.75-1.3 2-1.46.22-.16h.36a4.44 4.44 0 0 0 4.06-3.64 5.57 5.57 0 0 0 0-1.58A4.54 4.54 0 0 0 16.11 1zM9.3 13.06a2.52 2.52 0 0 1-.76 1.23 2.44 2.44 0 0 1-1.32.71 2.32 2.32 0 0 1-.91 0 2.68 2.68 0 0 1-1.83-1.3.9.9 0 0 1-.14-.27l.9.36c.49.21 1 .39 1.06.42a2.37 2.37 0 0 0 .92 0 2 2 0 0 0 1.39-1.4 2.48 2.48 0 0 0 0-.86 2 2 0 0 0-.7-1.11 6.2 6.2 0 0 0-1.36-.65c-.74-.31-.74-.31-.65-.35a3.19 3.19 0 0 1 1.51-.05 3.09 3.09 0 0 1 1 .5 2.79 2.79 0 0 1 .92 1.4 3 3 0 0 1-.03 1.37zm7.84-7.59a2.89 2.89 0 0 1-.85 1.66 3 3 0 0 1-5.11-1.6 3.43 3.43 0 0 1 0-1.15A3 3 0 0 1 13.62 2a3.87 3.87 0 0 1 1.27 0 3.11 3.11 0 0 1 2.21 2.26 3.08 3.08 0 0 1 .04 1.21z"
});

var SvgSteam = function SvgSteam(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 19.18 16.29",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSteam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steam.e1997495.svg";
export { ForwardRef as ReactComponent };